module.exports = __webpack_public_path__ + "assets/img/heroPrivate_b.377c8313.jpg";